module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADpSURBVHgB7VZBDoIwEGwJv/BOvKhnTNQ/6TvkT2qiZ/ViuPsNard2k1KC3bUEEsKcFugwdNplKpfZ5i0YeJSXGdZcbiJ6RK9iqXvhWuSCYheFm/oPF/NdnlRqDXWVyOvzdboJIkLchhgMVkLtv7W5RRYLcYdbMwBM336VqQUDIW5DzPpMto7DrYlxm5TLHW9TT+gEssuIkUIW9/J8hHqVbQ/4N0FMEUOyGmzTY9G6wn9fVMTAGtXEpMq1Yt42PipicDMg7Kagi/0LsFoLmbptx0ZFDMwEaxT6haiI8fuIJRYTMZTz5Hib+gOOsIkprjwubgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/VectorLMG.png
// module id = gHS0
// module chunks = 1